import React, { FC, memo, useEffect } from 'react';
import { sentryHub } from '@app/shared/utils/sentry';
import { usePublicEnv } from '@app/shared/contexts/PublicEnv';
import type { SentryProviderProps } from './SentryProvider.type';

export const SentryProvider: FC<SentryProviderProps> = memo(({ children, standalone }) => {
  const { user, environment, country } = usePublicEnv();

  useEffect(() => {
    try {
      sentryHub.init({ environment, standalone });
      sentryHub.setUser({ id: user?.userId });
      sentryHub.setTag('country', country?.shortName);
      sentryHub.setTag('templateType', TEMPLATE_TYPE);
      sentryHub.setTag('templateVersion', TEMPLATE_VERSION);
      sentryHub.startSession();
    } catch (error) {
      console.error('Error initializing sentry hub', (error as Error).message);
    }
  }, [country?.shortName, environment, user?.userId]);

  return children;
});
